import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';

import Dialog from '../ui/Dialog';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay.component';
import { getLatestPendingCodeMessage } from '../../services/customer.service';
import { getLatestMessageByCodeAndPatientId, resendMessage } from '../../services/message.service';

const useStyles = makeStyles(() => ({
  field: {
    marginBottom: 10,
    width: '100%'
  },
  select: {
    width: '100%'
  },
  formControl: {
    width: '100%'
  }
}));

const ResendVoucherCode = ({ data }) => {
  const { patient_id, program_id, mobile_number, chosen_language, code } = data;
  const classes = useStyles();

  const [state, setState] = useState({
    openModal: true,
    openConfirmation: false,
    modalTitle: 'Resend Voucher Code',
    errorMessage: null,
    successMessage: 'Successfully resent voucher code!',
    isLoading: true,
    latestMessage: '',
    messageLogId: null,
    submitButtonEnabled: false,
  });

  useEffect(() => {
    const fetchLatestMessage = async () => {
      setState(prev => ({ ...prev, isLoading: true }));
      try {
        const { result } = await getLatestMessageByCodeAndPatientId({
          program_id,
          customer_id: patient_id,
          code: code
        });

        if (result?.message_log) {
          setState(prev => ({
            ...prev,
            latestMessage: result?.message_log.message,
            messageLogId: result?.message_log.id,
            submitButtonEnabled: true
          }));
        }
      } catch (error) {
        setState(prev => ({
          ...prev,
          errorMessage: error.message
        }));
      } finally {
        setState(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchLatestMessage();
  }, [program_id, patient_id]);

  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openModal: false,
      openConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const onResend = async () => {
    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await resendMessage({
        program_id,
        payload: {
          message_log_id: state.messageLogId,
          recipient_id: patient_id,
          language: chosen_language,
          recipient_mobile_number: mobile_number
        }
      });

      if (response?.status === 200) {
        setState(prev => ({
          ...prev,
          openConfirmation: true,
          successMessage: response.message
        }));
      } else {
        setState(prev => ({
          ...prev,
          errorMessage: response.message
        }));
      }
    } catch (e) {
      setState(prev => ({
        ...prev,
        errorMessage: e.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const {
    openModal,
    openConfirmation,
    modalTitle,
    errorMessage,
    successMessage,
    isLoading,
    latestMessage,
    submitButtonEnabled
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formContent = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {latestMessage ? (
          <>
            <Typography>Latest Message</Typography>
            <Typography>{latestMessage}</Typography>
          </>
        ) : (
          <Typography>No latest message to resend</Typography>
        )}
      </Grid>
      {errorMessage && (
        <Grid item xs={12}>
          <Typography variant="caption" color="error">
            {errorMessage}
          </Typography>
        </Grid>
      )}
    </Grid>
  );

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {!openConfirmation && (
        <Button
          onClick={onResend}
          variant="contained"
          color="primary"
          disabled={!submitButtonEnabled}
        >
          Resend
        </Button>
      )}
    </>
  );

  return (
    <>
      <Dialog
        key="resend-purchase-code"
        open={openModal}
        title={modalTitle}
        content={formContent}
        children={formButtons}
        onSubmit={onResend}
        onClose={handleClose}
      />
      <Dialog
        onSubmit={() => handleClose()}
        key="confirmation"
        open={openConfirmation}
        title="Confirmation"
        content={successMessage}
        children={formButtons}
        onClose={handleClose}
      />
    </>
  );
};

export default  ResendVoucherCode;